<template>
  <el-dialog
    title="选择订单"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <div class="query-form">
      <el-row :gutter="20">
        <el-col :span="12" :offset="12">
          <el-input
            v-model="chooseStoreOrderInfo.orderId"
            placeholder="输入订单编号"
            clearable
            @keyup.enter.native="queryOrders">
            <el-button slot="append" type="primary" @click="queryOrders">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div class="table-container" style="margin-top: 15px;">
      <el-table
        :data="chooseStoreOrderInfo.orders"
        border
        stripe
        style="width: 100%">
        <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="personName" label="用户" align="center"></el-table-column>
        <el-table-column prop="totalPrice" label="总金额" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="chooseStoreOrder(scope.row)">
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="chooseStoreOrderInfo.total > 0"
        class="pagination-container"
        background
        layout="prev, pager, next"
        :total="chooseStoreOrderInfo.total"
        :current-page="chooseStoreOrderInfo.page"
        :page-size="chooseStoreOrderInfo.row"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryStoreOrder } from '@/api/order/storeOrderCartApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseStoreOrder',
  data() {
    return {
      dialogVisible: false,
      chooseStoreOrderInfo: {
        orderId: '',
        orders: [],
        page: 1,
        row: 10,
        total: 0,
        shopId: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.chooseStoreOrderInfo.shopId = getShopId()
      this.queryOrders()
    },
    handleClose() {
      this.chooseStoreOrderInfo.orderId = ''
      this.chooseStoreOrderInfo.orders = []
      this.chooseStoreOrderInfo.page = 1
      this.chooseStoreOrderInfo.total = 0
    },
    async queryOrders() {
      try {
        const params = {
          page: this.chooseStoreOrderInfo.page,
          row: this.chooseStoreOrderInfo.row,
          shopId: this.chooseStoreOrderInfo.shopId
        }
        
        if (this.chooseStoreOrderInfo.orderId) {
          params.orderId = this.chooseStoreOrderInfo.orderId.trim()
        }
        
        const res = await queryStoreOrder(params)
        this.chooseStoreOrderInfo.orders = res.data || []
        this.chooseStoreOrderInfo.total = res.total || 0
      } catch (error) {
        console.error('查询订单失败:', error)
        this.$message.error('查询订单失败')
        this.chooseStoreOrderInfo.orders = []
        this.chooseStoreOrderInfo.total = 0
      }
    },
    chooseStoreOrder(order) {
      // 单选模式：直接触发事件并关闭对话框
      this.$emit('chooseStoreOrder', order)
      this.dialogVisible = false
    },
    handleCurrentChange(val) {
      this.chooseStoreOrderInfo.page = val
      this.queryOrders()
    }
  }
}
</script>

<style scoped>
.query-form {
  margin-bottom: 15px;
}

.table-container {
  max-height: 500px;
  overflow-y: auto;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}
</style>